import { createStore } from 'effector';

export const $organizationData = createStore({name: '', organizations: []});

export const $organizationInfo = createStore({
  blocks: [],
  graphs: [],
});
